import { render, staticRenderFns } from "./OldImeiDetail.vue?vue&type=template&id=21ca290b&scoped=true"
import script from "./OldImeiDetail.vue?vue&type=script&lang=js"
export * from "./OldImeiDetail.vue?vue&type=script&lang=js"
import style0 from "./OldImeiDetail.vue?vue&type=style&index=0&id=21ca290b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca290b",
  null
  
)

export default component.exports